<template>
  <div class="ranking-list-card-style2">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <el-tooltip v-if="tooltip" effect="dark" :content="tooltip" placement="top" style="margin-left: 4px">
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <i class="separator"></i>
        <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div class="operation-bar">
          <div class="operation-bar-left">
            <!--eslint-disable vue/no-unused-refs vue/no-mutating-props -->
            <!-- 忽略 form is defined as ref、Unexpected mutation of 'filterModel' prop(20、24行) -->
            <el-form ref="form" :model.sync="filterModel">
              <template v-for="(filter) in filterList">
                <div class="filter-wrapper" v-if="filter && filter.type === 'radio'" :key="filter.name">
                  <el-radio-group v-model="filterModel[filter.name]" size="small" @input="handleRadioChange">
                    <el-radio-button v-for="(item) in filter.options" :label="item.value" :key="item.value">{{item.label}}</el-radio-button>
                  </el-radio-group>
                </div>
              </template>
            </el-form>
            <!--eslint-enable-->
          </div>
          <div class="operation-bar-right" v-if="btnClickShow">
            <el-button type="text" @click="handleBtnClick">{{btnText}}</el-button>
          </div>
        </div>

        <QS-common-table
          class="ranking-table"
          :columns="tableColumns"
          :data="tableData"
          :maxHeight="248"
          :pagination="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 提示语
    tooltip: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 按钮文案
    btnText: {
      type: String,
      default: '',
    },
    // 筛选项列表
    filterList: {
      type: Array,
      default: () => [],
    },
    // 筛选项对象
    filterModel: {
      type: Object,
      default: () => ({}),
    },
    // 表格列配置
    tableColumns: {
      type: Array,
      default: () => [],
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    authority: {
      type: String,
      default: '',
    },
  },
  watch: {
    watch: {
      model: {
        handler(val) {
          this.$emit('radioChange', val)
        },
        deep: true,
        immediate: false,
      },
    },
  },
  methods: {
    handleRadioChange(val) {
      this.$emit('radioChange', val)
    },
    handleBtnClick() {
      this.$emit('btnClick')
    },
  },
  computed: {
    btnClickShow() {
      if (this.authority && !this.judgePermission(this.authority)) return false
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt12 {
  margin-top: 12px;
}
.ranking-list-card-style2 {
  border-radius: 2px;
  // overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      ::v-deep .QS-icon-question-outline {
        color: #C0C4CC;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
    .card-header-right {

    }
  }
  .card-body {
    .card-body-inner {
      height: 327px;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      // align-items: center;
      padding: 16px 16px 0 12px;
      border-left: 1px solid #ECEEF4;
      border-right: 1px solid #ECEEF4;
      border-bottom: 1px solid #ECEEF4;
      .operation-bar {
        display: flex;
        justify-content: space-between;
      }
      .ranking-table {
        flex: 1;
        margin-top: 16px;
        ::v-deep .el-table__empty-block {
          border: none
        }
      }
    }
  }
}
</style>
